<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Clients" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                        router-link.btn-default(to="/clients") 
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                            span.mr-2 Back
            //- .box__body
            .box__body
                .container-form(action="" method="method")
                    section.group-fields.border-b
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="name") Name *
                            .field__form
                                input.field-style(id="name" name="name" type="text" v-model="name" maxlength="255")
                                .error(v-if="error_name !== null") {{ error_name }}

                        .field(v-if="route_name === 'PageClientsCreate'")
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="email") Email *
                            .field__form
                                input.field-style(id="email" name="email" type="email" v-model="email" maxlength="255")
                                .error(v-if="error_email !== null") {{ error_email }}
                        template(v-else)
                            .field.field--disabled
                                .field__label
                                    label.block.text-sm.font-bold.mb-2(for="email") Email
                                .field__form
                                    input.field-style(id="email" name="email" type="email" disabled="disabled" v-model="email" maxlength="255" @keypress.prevent @paste.prevent)

                            .field.field--disabled
                                .field__label    
                                    label.block.text-sm.font-bold.mb-2(for="password") Password
                                .field__form
                                    input.field-style(id="password" type="text" name="password" disabled="disabled" v-model="password" @keypress.prevent @paste.prevent)

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="label") Label *
                            .field__form
                                input.field-style(id="label" name="label" type="text" v-model="label" maxlength="255")
                            .error(v-if="error_label !== null") {{ error_label }}

                        .field.field--disabled
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="key") Key *
                            .field__form
                                .flex.items-center
                                    input.field-style.readonly(id="key" name="key" type="text" v-model="key" maxlength="255" @keypress.prevent @paste.prevent)
                                    button.btn-icon.btn-icon-40.ml-4(
                                        v-if="route_name === 'PageClientsCreate'"
                                        type='button'
                                        @click="regenerateKey()"
                                        v-tooltip="'Regenerate Key'"
                                    ) 
                                        i.icon-btn
                                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                                .error(v-if="error_key !== null") {{ error_key }}

                        .field.field--disabled
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="secret") Secret *
                            .field__form
                                .flex.items-center
                                    input.field-style.readonly(id="secret" name="secret" type="text" v-model="secret" maxlength="255" @keypress.prevent @paste.prevent)
                                    button.btn-icon.btn-icon-40.ml-4(
                                        v-if="route_name === 'PageClientsCreate'"
                                        type='button'
                                        @click="regenerateSecret()"
                                        v-tooltip="'Regenerate Secret'"
                                    )
                                        i.icon-btn
                                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                                .error(v-if="error_secret !== null") {{ error_secret }}

                        .field.field--radio.mb-4
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="status") Status *
                            .field__form
                                .wrapper-radio(style="margin-right: 20px;")
                                    input(type="radio" name="status" value="1" v-model="status")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Active
                                .wrapper-radio
                                    input(type="radio" name="status" value="0" v-model="status")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Inactive
                                .error(v-if="error_status !== null") {{ error_status }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="description") Description
                            .field__form
                                textarea.field-style(id="description" name="description" v-model="description" style="min-height: 200px;")
                                .error(v-if="error_description !== null") {{ error_description }}


                    .flex.items-center.justify-end.mb-12
                        button.btn-default.ml-2(type='button' @click="reset()")
                            | Reset
                        button.btn-primary-o.ml-2(type='submit' @click="submit($event, true)")
                            | Save &amp; Continue
                        button.btn-primary.ml-2(type='submit' @click="submit")
                            | Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import { required, minLength } from 'vuelidate/lib/validators';
// import { encrypt,encryptBase64 } from '@/util/crypto';
import { encryptBase64 } from '@/util/crypto';
import moment from 'moment';

export default {
    name: 'PageClientsForm',
    components: {
        HeaderGlobal,
    },
    data: function() {
        return {
            name: '',
            email: '',
            // only show on edit page
            password: '',
            label: '',
            key: '',
            secret: '',
            status: '',
            description: '',
            // error message
            error_name: '',
            error_email: '',
            error_label: '',
            error_key: '',
            error_secret: '',
            error_status: '',
            error_description: '',
        };
    },
    validations: {
        name: {
            required,
            minLength: minLength(1)
        },
    },
    computed: {
        ...mapState([
            'load_data_status_clients_detail',
            'clients_detail',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit Client',
                url: '/clients/'+this.id+'/edit',
            };
            if (this.route_name === 'PageClientsCreate')
                page = {
                    name: 'Add Client',
                    url: '/clients/create',
                };

            return [
                {
                    name: 'Clients',
                    url: '/clients',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit Client';
            if (this.route_name === 'PageClientsCreate')
                title = 'Add Client';
            return title;
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        id() {},
        breadcrumb() {},
        page_title() {},
        // form data
        clients_detail(newData) {
            this.name = (newData.name ? newData.name : '');
            this.email = (newData.email ? newData.email : '');
            this.password = (newData.password ? newData.password : '');
            this.label = (newData.label ? newData.label : '');
            this.key = (newData.key ? newData.key : (this.route_name=='PageClientsCreate' ? this.generateKey() : ''));
            this.secret = (newData.secret ? newData.secret : (this.route_name=='PageClientsCreate' ? this.generateSecret() : ''));
            this.status = (newData.status ? (newData.status.toLowerCase() === 'active' ? '1' : '0') : '');
            this.description = (newData.description ? newData.description : '');
        },
        name() {},
        email() {},
        password() {},
        label(newData) {
            if (newData !== '' && newData !== null)
                this.label = newData.replace(/\s+/g, '-').toLowerCase();
        },
        key(newData) {
            if (newData !== '' && newData !== null)
                this.key = newData.replace(/\s+/g, '-');
        },
        secret(newData) {
            if (newData !== '' && newData !== null)
                this.secret = newData.replace(/\s+/g, '-');
        },
        status() {},
        description() {},
        // error message
        error_name() {},
        error_email() {},
        error_label() {},
        error_key() {},
        error_secret() {},
        error_status() {},
        error_description() {},
    },
    methods: {
        generateRandomString(length=25) {
            const allCapsAlpha = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"]; 
            const allLowerAlpha = [..."abcdefghijklmnopqrstuvwxyz"]; 
            // const allUniqueChars = [..."~!@#$%^&*()_+-=[]\{}|;:'",./<>?"];
            const allNumbers = [..."0123456789"];

            const base = [...allCapsAlpha, ...allNumbers, ...allLowerAlpha];

            const generator = (base, len) => {
               return [...Array(len)]
                /* eslint-disable no-unused-vars */
                .map(i => base[Math.random()*base.length|0])
                .join('');
            };

            return generator(base, length)+moment().unix();
        },
        generateKey() {
            return encryptBase64(this.generateRandomString(14), false);
        },
        generateSecret() {
            return encryptBase64(this.generateRandomString(22));
        },
        regenerateKey() {
            this.key = this.generateKey();
        },
        regenerateSecret() {
            this.secret = this.generateSecret();
        },
        validateEmail(email) {
            /* eslint-disable no-useless-escape */
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        getData() {
            // console.log('=================== getData() route on clients form')

            this.name = '';
            this.email = '';
            this.label = '';
            // this.key = this.generateKey();
            // this.secret = this.generateSecret();
            this.status = '';
            this.description = '';

            this.error_name = '';
            this.error_email = '';
            this.error_label = '';
            this.error_key = '';
            this.error_secret = '';
            this.error_status = '';
            this.error_description = '';

            if (this.route_name === 'PageClientsEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);

                this.$store.dispatch('getClientsDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            } else {
                if (this.route_name === 'PageClientsCreate')
                    this.$store.commit('setClientsDetail', {});
            }
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    if (this.route_name === 'PageClientsCreate') {
                        this.name = '';
                        this.email = '';
                        this.label = '';
                        // this.key = this.generateKey();
                        // this.secret = this.generateSecret();
                        this.status = '';
                        this.description = '';

                        this.error_name = '';
                        this.error_email = '';
                        this.error_label = '';
                        this.error_key = '';
                        this.error_secret = '';
                        this.error_status = '';
                        this.error_description = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
            e.preventDefault();
            // console.log('=================== submit() route on clients form')
            // console.log(e);

            // console.log([this.name, this.key, this.secret, this.status, this.description]);
            // this.getData();

            this.showLoading(true);

            this.error_name = '';
            this.error_email = '';
            this.error_label = '';
            this.error_key = '';
            this.error_secret = '';
            this.error_status = '';
            this.error_description = '';

            if (this.name.length==0 || (this.route_name === 'PageClientsCreate' ? this.email.length==0 : false) || this.label.length==0 || this.key.length==0 || this.secret.length==0 || this.status.length==0) {

                this.error_name = (this.name.length==0 ? 'Field name is required.' : '');
                this.error_email = (this.email.length==0 && this.route_name === 'PageClientsCreate' ? 'Field email is required.' : '');
                this.error_label = (this.label.length==0 ? 'Field label is required.' : '');
                this.error_key = (this.key.length==0 ? 'Field key is required.' : '');
                this.error_secret = (this.secret.length==0 ? 'Field secret is required.' : '');
                this.error_status = (this.status.length==0 ? 'Field status is required.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Name, '+ (this.route_name === 'PageClientsCreate' ? 'email, ' : '') +'label, key, secret, & status is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.name.length>255 || (this.route_name === 'PageClientsCreate' ? this.email.length>255 : false) || this.label.length>255 || this.key.length>255 || this.secret.length>255) {

                this.error_name = (this.name.length>255 ? 'Field name is not more than 255 characters.' : '');
                this.error_email = (this.email.length>255 && this.route_name === 'PageClientsCreate' ? 'Field email is not more than 255 characters.' : '');
                this.error_label = (this.label.length>255 ? 'Field label is not more than 255 characters.' : '');
                this.error_key = (this.key.length>255 ? 'Field key is not more than 255 characters.' : '');
                this.error_secret = (this.secret.length>255 ? 'Field secret is not more than 255 characters.' : '');
                // this.error_status = (this.status.length>255 ? 'Field status is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Name, '+ (this.route_name === 'PageClientsCreate' ? 'email, ' : '') +'label, key, & secret is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            if (this.route_name === 'PageClientsCreate' && !this.validateEmail(this.email)) {
                this.error_email = 'The email must be a valid email address.';

                this.$swal.fire({
                    title: 'Email must be a valid email address.',
                    icon: 'warning',
                    // timer: 3000,
                });
                return;
            }

            if (this.route_name === 'PageClientsCreate') {

                this.$store.dispatch('getClientsCreate', [this.name, this.email, this.label, this.key, this.secret, this.status, this.description])
                .then((resp) => {

                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageClientsIndex' });
                        if (save_continue === false) {
                            this.$router.push('/clients');
                        } else {
                            this.$router.push('/clients/'+ resp.data.data.id +'/edit');
                        }

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                    } else {

                        if (resp.data.message && resp.data.message.errors) {
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_email = (resp.data.message.errors.email ? resp.data.message.errors.email : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            this.error_key = (resp.data.message.errors.key ? resp.data.message.errors.key : '');
                            this.error_secret = (resp.data.message.errors.secret ? resp.data.message.errors.secret : '');
                            this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });

            // PageClientsEdit
            } else {

                this.$store.dispatch('getClientsUpdate', [this.id, this.name, this.label, this.key, this.secret, this.status, this.description])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageClientsIndex' });
                        
                        if (save_continue === false)
                            this.$router.push('/clients');

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {
                        
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_email = (resp.data.message.errors.email ? resp.data.message.errors.email : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            this.error_key = (resp.data.message.errors.key ? resp.data.message.errors.key : '');
                            this.error_secret = (resp.data.message.errors.secret ? resp.data.message.errors.secret : '');
                            this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        // console.log('=================== mounted on Clients form')
        this.getData();
    },
   
}
</script>

<style lang="sass">

.field--search
    input
        min-width: 320px
    svg
        width: 24px
        height: 24px
        stroke: #a0aec0

.client-status-active
    color: #48bb78
    // font-size: 13px

.client-status-inactive
    color: #fe5d70
    // font-size: 13px

// input[readonly]
input.readonly
    background: #1e3054
    color: #63779e
    &::focus
        outline: none
        box-shadow: unset

// error field
.error 
    color: red

</style>
